import { formatDate } from '@angular/common';

import { formats } from '@environment';

export function formatDateLong(value: string | Date, format: string = formats.dateLongFormat): string {
  if (!value) {
    return null;
  }

  return formatDate(value, format, 'en-US', 'GMT');
}
